import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class TerraceGardens5PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.TERRACE_GARDENS5;
}

export default TerraceGardens5PoiTileEntity;
